import { ProgramId } from '@shared/constants';

export const moduleName = 'references';

export const refrencesDetails = [
  {
    value: 'cubScouts',
    programId: ProgramId.CUB_SCOUT,
    link: 'https://www.scouting.org/programs/cub-scouts/#bsa-slider-section',
  },
  {
    value: 'scoutsBSA',
    programId: ProgramId.BOY_SCOUT,
    link: 'https://www.scouting.org/programs/scouts-bsa/#bsa-slider-section',
  },
  {
    value: 'venturing',
    programId: ProgramId.VENTURING,
    link: 'https://www.scouting.org/programs/venturing/#bsa-slider-section',
  },
  {
    value: 'seaScouting',
    programId: ProgramId.SEA_SCOUT,
    link: 'https://seascout.org/advancement-central/',
  },
  {
    value: 'exploring',
    programId: ProgramId.EXPLORING,
    link: 'https://www.exploring.org/#exploring-resources',
  },
];
